import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout';
import { getApiUrl } from './config';

function Products() {
    const role = localStorage.getItem("role") || "user";
    const isAdmin = role === "admin";
    const [products, setProducts] = useState([]);
    const [newProduct, setNewProduct] = useState({ name: '', category: '', unit: '', price: 0, godown_qty: 0, godown_weight: 0 });
    const [editingId, setEditingId] = useState(null);

    useEffect(() => {
        fetchProducts();
    }, []);

    const fetchProducts = async () => {
        try {
            const res = await axios.get(`${getApiUrl()}/products`);
            setProducts(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleSaveProduct = async (e) => {
        e.preventDefault();
        try {
            if (editingId) {
                if (!isAdmin) return alert("Only admin can update records");
                await axios.put(`${getApiUrl()}/products/${editingId}`, newProduct);
            } else {
                await axios.post(`${getApiUrl()}/products`, newProduct);
            }
            setNewProduct({ name: '', category: '', unit: '', price: 0, godown_qty: 0, godown_weight: 0 });
            setEditingId(null);
            fetchProducts();
        } catch (err) {
            console.error(err);
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${getApiUrl()}/products/${id}`);
            fetchProducts();
        } catch (err) {
            console.error(err);
            const message =
                err?.response?.data?.message ||
                err?.response?.data?.sqlMessage ||
                err?.response?.data?.code ||
                "Failed to delete product";
            alert(message);
        }
    };

    const startEdit = (p) => {
        setEditingId(p.id);
        setNewProduct({
            name: p.name || '',
            category: p.category || '',
            unit: p.unit || '',
            price: parseFloat(p.price) || 0,
            godown_qty: parseInt(p.godown_qty ?? p.stock) || 0,
            godown_weight: parseFloat(p.godown_weight) || 0
        });
    };

    const cancelEdit = () => {
        setEditingId(null);
        setNewProduct({ name: '', category: '', unit: '', price: 0, godown_qty: 0, godown_weight: 0 });
    };

    return (
        <Layout>
            <div className="container mt-4">
                <h2>Products</h2>
                <form onSubmit={handleSaveProduct} className="mb-4">
                    <div className="row g-3">
                        <div className="col-md-3">
                            <input type="text" className="form-control" placeholder="Product Name" value={newProduct.name} onChange={e => setNewProduct({...newProduct, name: e.target.value})} onFocus={(e) => e.target.select()} required />
                        </div>
                        <div className="col-md-2">
                            <input type="text" className="form-control" placeholder="Category" value={newProduct.category} onChange={e => setNewProduct({...newProduct, category: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-md-2">
                            <input type="text" className="form-control" placeholder="Unit" value={newProduct.unit} onChange={e => setNewProduct({...newProduct, unit: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-md-2">
                            <input type="number" className="form-control" placeholder="Price" value={newProduct.price} onChange={e => setNewProduct({...newProduct, price: parseFloat(e.target.value)})} onFocus={(e) => e.target.select()} required />
                        </div>
                        <div className="col-md-2">
                            <input type="number" className="form-control" placeholder="Godown Qty" value={newProduct.godown_qty} onChange={e => setNewProduct({...newProduct, godown_qty: parseInt(e.target.value)})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-md-2">
                            <input type="number" className="form-control" placeholder="Godown Weight" value={newProduct.godown_weight} onChange={e => setNewProduct({...newProduct, godown_weight: parseFloat(e.target.value)})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-md-2 d-grid">
                            <button type="submit" className={`btn ${editingId ? 'btn-warning' : 'btn-primary'}`}>{editingId ? 'Update' : 'Add'}</button>
                        </div>
                        {editingId && (
                            <div className="col-md-2 d-grid">
                                <button type="button" className="btn btn-secondary" onClick={cancelEdit}>Cancel</button>
                            </div>
                        )}
                    </div>
                </form>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Category</th>
                                <th>Unit</th>
                                <th>Price</th>
                                <th>Godown Qty</th>
                                <th>Godown Weight</th>
                                {isAdmin && <th>Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {products.map(p => (
                                <tr key={p.id}>
                                    <td>{p.name}</td>
                                    <td>{p.category}</td>
                                    <td>{p.unit}</td>
                                    <td>{p.price}</td>
                                    <td>{p.godown_qty ?? p.stock}</td>
                                    <td>{parseFloat(p.godown_weight || 0).toFixed(2)}</td>
                                    {isAdmin && (
                                        <td>
                                            <button type="button" className="btn btn-warning btn-sm me-1" onClick={() => startEdit(p)}>Edit</button>
                                            <button type="button" className="btn btn-danger btn-sm" onClick={() => handleDelete(p.id)}>Delete</button>
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Layout>
    );
}

export default Products;
